export default {
  ModelObj: {
    login: {
      usernamePlaceholder: 'Bitte geben sie einen benutzernamen ein',
      passwordPlaceholder: 'Code eingeben.'
    },
    title: '请输入用户名',
    rAddBtn: '请输入用户名',
    searchSelect: {
      optionLabel1: '所有状态',
      optionLabel2: '启动',
      optionLabel3: '禁止'
    },
    filterInputplac: '请输入模板标题',
    searchBtn: '搜索',
    resetBtn: '重置',
    table: {
      colu1: '模板标题',
      colu2: '发布者',
      colu3: '创建时间',
      colu4: '状态',
      colu5: '操作',
      operationbtn1: '管理字段',
      operationbtn2: '修改',
      operationbtn3: '删除'
    }
  }
}


// WEBPACK FOOTER //
// ./src/lang/i18n-gm.js